import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { Transition, TransitionGroup } from 'react-transition-group';

import { BREAK_POINT } from 'constants/responsive';

import './Cart.sass';

export interface StateProps {
    productsCount: number;
    addedItemText: string;
    isMobile: boolean;
    headerShowing: boolean;
}

const defaultMessageStyle = {
    opacity: 0,
    transition: 'opacity 500ms linear'
};

const transitionStyles: { [key: string]: any; } = {
    entering: {
        opacity: 0
    },
    entered: { // tslint:disable-line:object-literal-sort-keys
        opacity: 1
    }
};

const Cart: React.StatelessComponent<StateProps> = (props: StateProps) => {
    const { addedItemText, headerShowing, isMobile, productsCount } = props;
    if (productsCount < 1) {
        return <div className="cart-wrapper"/>;
    }
    return (
        <div className="cart-wrapper">
            <div className={`cart-container${isMobile ? '-mobile' : headerShowing ? '' : '-stickied' }`}>
                <div className="cart-circle">
                    <Link to="/accessories/cart">
                        <div className="products-count-circle">{productsCount}</div>
                        <FontAwesome className="cart-icon" name="shopping-cart" size="3x" />
                    </Link>
                </div>
                <TransitionGroup className="transition-group">
                {addedItemText &&
                    <Transition className timeout={{ enter: 0, exit: 500 }} >
                    {(state: string) => {
                        return (<div className="cart-message" style={{ ...defaultMessageStyle, ...transitionStyles[state] }}>
                            <div className="arrow-right">&nbsp;</div>{addedItemText} added to your <Link to="/accessories/cart">cart</Link>.
                        </div>);
                    }}
                    </Transition>
                }
                </TransitionGroup>
            </div>
        </div>
    );
};

export default Cart;



// WEBPACK FOOTER //
// ./src/components/pages/accessories/Cart.tsx